import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    office: String,
    productType: String,
  };

  connect() {
    if (this.productTypeValue) {
      this.updateOptionState(this.productTypeValue);
    }
  }

  reload(event) {
    const productType = event.target.value;
    if (productType) {
      this.updateOptionState(productType);
    }
  }

  async updateOptionState(productType) {
    const params = {
      office_id: this.officeValue,
      product_type: productType,
    };

    const route = "/turbo_streams/appointments/reload_date_picker";

    const response = await fetch(route, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
          .content,
      },
      credentials: "same-origin",
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      console.error(
        `Failed to reload date picker: ${response.status} ${response.statusText}`
      );
      return;
    }

    const html = await response.text();
    Turbo.renderStreamMessage(html);
  }
}
